<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar elevation-4 sidebar-dark-marron">
        <a href="#" class="brand-link animation__shake wow fadeInDown" style="align-items: center;position: absolute;top: 25px;"
            data-widget="pushmenu" role="button">
            <center>
                <i class="fas fa-align-right text-white"></i>&nbsp;<img src="../../../assets/img/logojateng.png"
                    alt="Admin Logo" class="animation__shake wow fadeInDown" style="opacity: .8;height: 35px;">
            </center>
        </a>
        <!-- Sidebar -->
        <div class="sidebar wow fadeInLeft">
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column nav-flat" data-widget="treeview" role="menu"
                    data-accordion="false">
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-header text-warning" style="font-size: large;">DASHBOARD</li>
                    <li class="nav-item">
                        <router-link to="/Dashboard"
                            :class="[(route.name == 'Dashboard' ? 'nav-link active' : 'nav-link')]" id="Dashboard"><i
                                class="nav-icon fas fa-chart-line"></i>
                            <p>DASHBOARD</p>
                        </router-link>
                    </li>
                    <li class="nav-header text-warning" style="font-size: large;">DATA</li>
                    <li class="nav-item">
                        <router-link to="/Rumah"
                            :class="[((route.name == 'Rumah' || route.name == 'ProsesRumah') ? 'nav-link active' : 'nav-link')]"
                            id="Rumah"><i class="nav-icon fas fa-clinic-medical"></i>
                            <p>RUMAH</p>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/KK"
                            :class="[((route.name == 'KK' || route.name == 'ProsesKK') ? 'nav-link active' : 'nav-link')]"
                            id="KK"><i class="nav-icon fas fa-credit-card"></i>
                            <p>JUMLAH KK PER KELURAHAN</p>
                        </router-link>
                    </li>
                    <li class="nav-header text-warning" style="font-size: large;">PENGATURAN</li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/Kategori"
                            :class="[((route.name == 'Kategori' || route.name == 'ProsesKategori') ? 'nav-link active' : 'nav-link')]"
                            id="Kategori"><i class="nav-icon fas fa-bahai"></i>
                            <p>KATEGORI DATA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/SubKategori"
                            :class="[((route.name == 'SubKategori' || route.name == 'ProsesSubKategori') ? 'nav-link active' : 'nav-link')]"
                            id="SubKategori"><i class="nav-icon fab fa-bandcamp"></i>
                            <p>SUB KATEGORI DATA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/UnitKategori"
                            :class="[((route.name == 'UnitKategori' || route.name == 'ProsesUnitKategori') ? 'nav-link active' : 'nav-link')]"
                            id="UnitKategori"><i class="nav-icon fab fa-bitbucket"></i>
                            <p>UNIT KATEGORI DATA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/Slider"
                            :class="[((route.name == 'Slider' || route.name == 'ProsesSlider') ? 'nav-link active' : 'nav-link')]"
                            id="Slider"><i class="nav-icon fas fa-photo-video"></i>
                            <p>SLIDER GAMBAR</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/InfoBeranda"
                            :class="[((route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]"
                            id="InfoBeranda"><i class="nav-icon fas fa-box"></i>
                            <p>INFO BERANDA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/Regulasi"
                            :class="[((route.name == 'Regulasi' || route.name == 'ProsesRegulasi') ? 'nav-link active' : 'nav-link')]"
                            id="Regulasi"><i class="nav-icon far fa-file-pdf"></i>
                            <p>REGULASI</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser <= 2">
                        <router-link to="/KategoriData"
                            :class="[((route.name == 'KategoriData' || route.name == 'ProsesKategoriData') ? 'nav-link active' : 'nav-link')]"
                            id="KategoriData"><i class="nav-icon fas fa-boxes"></i>
                            <p>KATEGORI DATA PETA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser <= 2">
                        <router-link to="/LayerPeta"
                            :class="[((route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta') ? 'nav-link active' : 'nav-link')]"
                            id="LayerPeta"><i class="nav-icon fas fa-layer-group"></i>
                            <p>LAYER PETA</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1">
                        <router-link to="/User"
                            :class="[((route.name == 'User' || route.name == 'ProsesUser') ? 'nav-link active' : 'nav-link')]"
                            id="User"><i class="nav-icon fas fa-user-friends"></i>
                            <p>PENGGUNA</p>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link" @click="keluar()">
                            <i class="nav-icon fas fa-sign-out-alt"></i>
                            <p>KELUAR / LOGOUT</p>
                        </a>
                    </li>
                    <li>&nbsp;</li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
    components: {
        swal
    },
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            folderawal: encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                localStorage.removeItem('tokensistem');
                localStorage.removeItem('usistem');
                localStorage.removeItem('lsistem');
                localStorage.removeItem('nmlsistem');
                localStorage.removeItem('emlsistem');
                localStorage.removeItem('nmusistem');
                localStorage.removeItem('tsistem');
                localStorage.removeItem('orsistem');
                localStorage.removeItem('bdlsistem');
                localStorage.removeItem('sbdsistem');
                localStorage.removeItem('jbtsistem');
            }
        },
        pindahawalnya1(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data/" + bytes);
        },
        pindahawalnya3(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data3/" + bytes);
        },
        pindahawalnya4(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data4/" + bytes);
        },
        pindahawalnya5(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data5/" + bytes);
        },
        pindahawalnya6(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data6/" + bytes);
        },
        pindahawalnya7(){
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data7/" + bytes);
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#2176e6",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorage();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if ((localStorage.getItem("tokensistem") == null)) {
            window.location.replace("/Login");
        }
    }
}
</script>

<style></style>